/** @jsx jsx */
import { jsx } from "@emotion/core";
import { List } from "@chakra-ui/core";

const OrderedList = ({ children, ...props }) => (
  <List as="ol" styleType="decimal" pl={4} {...props}>
    {children}
  </List>
);

export default OrderedList;
